import {
  LIMIT_REACHED,
  OVER_90,
  USAGE_LIMIT_DANGER,
  USAGE_LIMIT_WARNING,
} from '@/constants/billing';
import type { CreditLimitStatusType } from '@/utils/creditLimitStatus';

type RecordStatusType = typeof OVER_90 | typeof LIMIT_REACHED | null;

type UsageLimitAlertType = {
  type: typeof USAGE_LIMIT_WARNING | typeof USAGE_LIMIT_DANGER;
  buttonText: string;
  message: string;
  dismissable: boolean;
};

const RECORD_ONLY_MESSAGES = {
  [OVER_90]: 'You’ve used over 90% of your Record Export limit',
  [LIMIT_REACHED]: 'You’ve used 100% of your Record Export limit',
};

const CREDIT_ONLY_MESSAGES = {
  warning: 'You’ve used over 90% of your credits',
  danger: 'You’ve used 100% of your credits',
};

const BOTH_MESSAGES = {
  warning: 'You’re approaching your Record Export and credit limits',
  danger: 'You’ve hit your Record Export and credit limits',
};

const MIXED_RECORD_DANGER =
  'You’ve hit your Record Export limit and are approaching your credit limit';
const MIXED_CREDIT_DANGER =
  'You’ve hit your credit limit and are approaching your Record Export limit';

export function buildUsageLimitAlert(
  recordStatus: RecordStatusType,
  creditStatus: CreditLimitStatusType,
): UsageLimitAlertType | null {
  if (!recordStatus && !creditStatus) return null;

  const recordDanger = recordStatus === LIMIT_REACHED;
  const creditDanger = creditStatus === 'danger';
  const type =
    recordDanger || creditDanger ? USAGE_LIMIT_DANGER : USAGE_LIMIT_WARNING;

  if (recordStatus && !creditStatus) {
    return buildAlert(type, RECORD_ONLY_MESSAGES[recordStatus]);
  }
  if (creditStatus && !recordStatus) {
    return buildAlert(type, CREDIT_ONLY_MESSAGES[creditStatus]);
  }
  if (recordDanger && !creditDanger) {
    return buildAlert(type, MIXED_RECORD_DANGER);
  }
  if (creditDanger && !recordDanger) {
    return buildAlert(type, MIXED_CREDIT_DANGER);
  }
  return buildAlert(
    type,
    recordDanger ? BOTH_MESSAGES.danger : BOTH_MESSAGES.warning,
  );
}

function buildAlert(
  type: UsageLimitAlertType['type'],
  message: string,
): UsageLimitAlertType {
  return {
    type,
    buttonText: 'Contact us',
    message,
    dismissable: true,
  };
}
